// Datos de las páginas por sector (SEO + Ads + outbound).
// Para enriquecer una: edita su bloque. Para añadir: copia la estructura.
// slug = URL: /para/<slug>
// title/meta = SEO por página. beneficio = franja destacada. faqs = objeciones + schema.

const FAQ_COMUNES = [
  { q: "¿Necesito saber de tecnología?", a: "No. Eliges tu sector, pones tus datos (horarios, servicios, tono) y ya está funcionando. Sin instalar nada." },
  { q: "¿Y si el agente se equivoca?", a: "Tú decides qué hace solo y qué necesita tu aprobación. Cada acción queda registrada y tienes un botón para pararlo todo al instante." },
  { q: "¿Cuánto cuesta?", a: "Desde 29€/mes. Empiezas gratis, sin tarjeta, y cancelas cuando quieras." },
];

export const SECTORS = [
  {
    slug: "restaurantes",
    name: "Restaurantes",
    title: "IA para restaurantes · Reservas y atención 24/7 | Agent Company OS",
    meta: "Un agente de IA que coge reservas por teléfono y WhatsApp 24/7, resuelve dudas de la carta y reduce los no-shows. Empieza gratis, sin tarjeta.",
    h1: "La IA que atiende tu restaurante y no pierde ni una reserva",
    sub: "Contesta llamadas y WhatsApp 24/7, coge reservas, resuelve dudas de la carta y avisa de los no-shows. Tú, a cocinar.",
    beneficio: "Cada llamada que hoy se pierde es una mesa vacía. Recupéralas todas.",
    pains: [
      "Se pierden llamadas en hora punta = mesas vacías.",
      "Reservas por WhatsApp a deshora que nadie contesta.",
      "No-shows que te dejan la sala a medias.",
    ],
    does: [
      "Coge reservas por teléfono y WhatsApp, a cualquier hora.",
      "Responde carta, alérgenos, horarios y ubicación al instante.",
      "Confirma la reserva 24h antes para reducir no-shows.",
      "Gestiona lista de espera y grupos grandes.",
    ],
    agents: ["Recepción y reservas", "Atención al cliente", "Anti no-shows", "Reseñas"],
    faqs: [
      { q: "¿Coge reservas de verdad o solo responde?", a: "Las coge de verdad: crea la reserva, la confirma y la mete en tu sistema. No solo contesta, ejecuta." },
      { q: "¿En qué idiomas atiende a mis clientes?", a: "En el idioma del cliente (español por defecto, e inglés y otros). Ideal si tienes turistas." },
      { q: "¿Puede reducir los no-shows?", a: "Sí. Envía una confirmación automática 24h antes; los clientes que no van avisan y liberas la mesa." },
    ],
  },
  {
    slug: "peluquerias",
    name: "Peluquerías y barberías",
    title: "IA para peluquerías y barberías · Citas por WhatsApp 24/7",
    meta: "Un agente de IA que coge citas por WhatsApp y teléfono mientras trabajas, envía recordatorios y rellena los huecos. Empieza gratis.",
    h1: "La IA que llena tu agenda de citas mientras trabajas",
    sub: "Coge citas por WhatsApp y teléfono aunque tengas las manos ocupadas, recuerda a los clientes y rellena los huecos.",
    beneficio: "No sueltes las tijeras para coger el teléfono. Deja que lo haga la IA.",
    pains: [
      "No puedes coger el teléfono con un cliente en la silla.",
      "Huecos sin cubrir cuando alguien cancela.",
      "Clientes que se olvidan de la cita.",
    ],
    does: [
      "Reserva y reprograma citas 24/7 por WhatsApp o teléfono.",
      "Envía recordatorios para reducir plantones.",
      "Ofrece los huecos libres a la lista de espera.",
      "Informa de servicios, precios y promociones.",
    ],
    agents: ["Citas y agenda", "Recordatorios", "Lista de espera", "Promociones"],
    faqs: [
      { q: "¿Se conecta con mi agenda actual?", a: "Se integra con tu sistema de citas mediante conexiones (n8n/webhooks) para no duplicar trabajo." },
      { q: "¿Puede rellenar un hueco de una cancelación?", a: "Sí. Cuando alguien cancela, avisa a tu lista de espera y ofrece el hueco automáticamente." },
      { q: "¿Atiende también por Instagram o solo WhatsApp?", a: "Por WhatsApp y teléfono de serie; otros canales se pueden conectar según tu caso." },
    ],
  },
  {
    slug: "clinicas",
    name: "Clínicas y consultas",
    title: "IA para clínicas · Gestión de citas y atención al paciente 24/7",
    meta: "Un agente de IA que agenda y confirma citas, resuelve dudas de tus pacientes y libera tu recepción del teléfono. Empieza gratis.",
    h1: "La IA que gestiona las citas de tu clínica sin líos",
    sub: "Atiende a tus pacientes 24/7, agenda y confirma citas, y libera a tu recepción del teléfono.",
    beneficio: "Tu recepción, para el paciente que tienes delante. El teléfono, para la IA.",
    pains: [
      "Recepción saturada de llamadas para pedir cita.",
      "Ausencias que dejan huecos sin aprovechar.",
      "Dudas repetidas de horarios, seguros y preparación.",
    ],
    does: [
      "Agenda, modifica y cancela citas por teléfono y WhatsApp.",
      "Confirma y recuerda la cita para reducir ausencias.",
      "Responde dudas frecuentes de forma clara.",
      "Deriva a una persona los casos que lo necesiten.",
    ],
    agents: ["Citas", "Recordatorios", "Atención al paciente", "Derivación"],
    faqs: [
      { q: "¿Es adecuado para datos de salud?", a: "El agente gestiona citas y dudas generales; tú controlas qué información maneja y todo queda auditado. Los casos clínicos se derivan a una persona." },
      { q: "¿Reduce las ausencias?", a: "Sí, con confirmaciones y recordatorios automáticos que bajan mucho los huecos sin avisar." },
      { q: "¿Puede derivar urgencias a una persona?", a: "Sí. Detecta lo que necesita atención humana y lo pasa al profesional adecuado." },
    ],
  },
  {
    slug: "talleres",
    name: "Talleres y mecánica",
    title: "IA para talleres mecánicos · Citas y avisos 24/7",
    meta: "Un agente de IA que coge citas de revisión y reparación, da presupuestos orientativos y avisa cuando el coche está listo. Empieza gratis.",
    h1: "La IA que coge las citas de tu taller y no deja llamada sin atender",
    sub: "Reserva revisiones y reparaciones, informa de presupuestos y avisa cuando el coche está listo.",
    beneficio: "Bajo un coche no se coge el teléfono. Que no se te escape ni un cliente.",
    pains: [
      "Llamadas perdidas mientras estás bajo un coche.",
      "Clientes que preguntan mil veces si ya está listo.",
      "Agenda descuadrada y huecos muertos.",
    ],
    does: [
      "Coge citas de revisión, ITV y reparación 24/7.",
      "Informa de servicios y da presupuestos orientativos.",
      "Avisa al cliente cuando el vehículo está listo.",
      "Organiza la agenda para no dejar huecos.",
    ],
    agents: ["Citas", "Presupuestos", "Avisos", "Seguimiento"],
    faqs: [
      { q: "¿Puede dar presupuestos?", a: "Da presupuestos orientativos según tus tarifas; el cierre final lo confirmas tú." },
      { q: "¿Avisa al cliente cuando está listo?", a: "Sí, envía el aviso automático por WhatsApp o SMS cuando marcas el vehículo como terminado." },
      { q: "¿Sirve para ITV y revisiones periódicas?", a: "Sí, gestiona cualquier tipo de cita y puede recordar la próxima revisión o ITV." },
    ],
  },
  {
    slug: "inmobiliarias",
    name: "Inmobiliarias",
    title: "IA para inmobiliarias · Atiende y cualifica leads 24/7",
    meta: "Un agente de IA que contesta a cada interesado al instante, cualifica el lead y agenda visitas. Que no se te enfríe ningún contacto. Empieza gratis.",
    h1: "La IA que atiende cada lead de tu inmobiliaria al instante",
    sub: "Responde a interesados 24/7, cualifica, agenda visitas y no deja que se enfríe ningún contacto.",
    beneficio: "El primero que contesta se lleva la operación. Contesta siempre el primero.",
    pains: [
      "Leads que se enfrían por tardar en contestar.",
      "Perder tiempo con curiosos que no van en serio.",
      "Coordinar visitas es un ida y vuelta eterno.",
    ],
    does: [
      "Contesta al momento a cada interesado, día y noche.",
      "Cualifica al lead (presupuesto, zona, urgencia).",
      "Agenda visitas y las mete en tu calendario.",
      "Envía info de inmuebles que encajan.",
    ],
    agents: ["Captación de leads", "Cualificación", "Agenda de visitas", "Seguimiento"],
    faqs: [
      { q: "¿Cualifica a los interesados?", a: "Sí. Pregunta presupuesto, zona y urgencia, y te prioriza los leads que valen la pena." },
      { q: "¿Se conecta con los portales (Idealista, etc.)?", a: "Los contactos de portales se pueden canalizar hacia el agente para que responda al instante." },
      { q: "¿Agenda visitas solo?", a: "Sí, cuadra la visita con tu disponibilidad y la mete en tu calendario." },
    ],
  },
  {
    slug: "tiendas",
    name: "Tiendas y comercio",
    title: "IA para tiendas y comercios · Atención y ventas 24/7",
    meta: "Un agente de IA que responde dudas de producto, stock y envíos por WhatsApp, recomienda y recupera clientes. Vende también fuera de horario. Empieza gratis.",
    h1: "La IA que atiende a tus clientes y vende también fuera de horario",
    sub: "Responde dudas de productos, stock y envíos por WhatsApp, y recupera carritos y clientes.",
    beneficio: "Tu tienda no cierra a las 20:00 si tienes quien atienda a medianoche.",
    pains: [
      "Preguntas de stock y envíos a todas horas.",
      "Clientes que se van si no contestas rápido.",
      "Sin manos para atender online y la tienda a la vez.",
    ],
    does: [
      "Responde disponibilidad, precios y envíos 24/7.",
      "Recomienda productos y resuelve dudas.",
      "Gestiona pedidos y estado de envíos.",
      "Recupera clientes que no terminaron de comprar.",
    ],
    agents: ["Atención al cliente", "Ventas", "Pedidos y envíos", "Recuperación"],
    faqs: [
      { q: "¿Vende o solo informa?", a: "Ayuda a decidir, recomienda y guía la compra; puede gestionar el pedido según tu montaje." },
      { q: "¿Sirve para tienda física y online?", a: "Para las dos: atiende consultas de la tienda y de tu web/WhatsApp." },
      { q: "¿Recupera clientes que no compraron?", a: "Sí, hace seguimiento a quien mostró interés y no cerró la compra." },
    ],
  },
  {
    slug: "gimnasios",
    name: "Gimnasios y centros deportivos",
    title: "IA para gimnasios · Capta socios y gestiona clases 24/7",
    meta: "Un agente de IA que informa de tarifas y clases, apunta a pruebas gratis y reduce las bajas con seguimiento. Empieza gratis, sin tarjeta.",
    h1: "La IA que capta socios y gestiona tu gimnasio 24/7",
    sub: "Informa de tarifas y clases, apunta a pruebas gratis y reduce las bajas con seguimiento.",
    beneficio: "Quien pregunta a las 23h y no recibe respuesta, se apunta en otro sitio.",
    pains: [
      "Interesados que preguntan de noche y no hay nadie.",
      "Reservas de clases que colapsan el mostrador.",
      "Bajas de socios que no ves venir.",
    ],
    does: [
      "Informa de cuotas, horarios y clases al instante.",
      "Apunta a clases de prueba y gestiona altas.",
      "Reserva plazas de clases dirigidas.",
      "Hace seguimiento para retener socios.",
    ],
    agents: ["Captación", "Reservas de clases", "Altas", "Retención"],
    faqs: [
      { q: "¿Gestiona las reservas de clases?", a: "Sí, reserva y cancela plazas de clases dirigidas y avisa si se llenan." },
      { q: "¿Ayuda a retener socios?", a: "Hace seguimiento a los socios en riesgo (poca asistencia) para reactivarlos antes de la baja." },
      { q: "¿Capta interesados fuera de horario?", a: "Sí, responde y apunta a pruebas gratis las 24h, cuando más gente busca gimnasio." },
    ],
  },
  {
    slug: "asesorias",
    name: "Asesorías y despachos",
    title: "IA para asesorías y despachos · Filtra y agenda consultas 24/7",
    meta: "Un agente de IA que recoge y clasifica consultas, cualifica al cliente y agenda citas. Menos teléfono, más trabajo de valor. Empieza gratis.",
    h1: "La IA que filtra y atiende las consultas de tu despacho",
    sub: "Recoge consultas 24/7, cualifica al cliente, agenda citas y te ahorra el teléfono constante.",
    beneficio: "Tu tiempo vale demasiado para gastarlo filtrando llamadas.",
    pains: [
      "Interrupciones constantes de teléfono y email.",
      "Consultas repetidas que te comen el tiempo.",
      "Clientes potenciales que se pierden entre tareas.",
    ],
    does: [
      "Atiende y clasifica consultas por área (fiscal, laboral…).",
      "Agenda citas con el profesional adecuado.",
      "Responde preguntas frecuentes y plazos.",
      "Recoge documentación y datos previos.",
    ],
    agents: ["Recepción", "Cualificación", "Agenda", "Documentación"],
    faqs: [
      { q: "¿Clasifica por tipo de consulta?", a: "Sí, distingue fiscal, laboral, contable, etc., y lo dirige al profesional correcto." },
      { q: "¿Recoge documentación previa?", a: "Puede pedir y recoger los datos y documentos que necesites antes de la cita." },
      { q: "¿Sustituye a mi personal?", a: "No: le quita lo repetitivo (teléfono, dudas, agenda) para que se centre en el cliente." },
    ],
  },
  {
    slug: "hoteles",
    name: "Hoteles y alojamientos",
    title: "IA para hoteles · Atención a huéspedes y reservas 24/7 multiidioma",
    meta: "Un agente de IA que responde reservas y dudas 24/7 en varios idiomas, hace upselling y mejora tus reseñas. Empieza gratis, sin tarjeta.",
    h1: "La IA que atiende a tus huéspedes antes, durante y después",
    sub: "Responde reservas y dudas 24/7 en varios idiomas, hace upselling y consigue mejores reseñas.",
    beneficio: "Un huésped bien atendido reserva directo, gasta más y deja 5 estrellas.",
    pains: [
      "Consultas a cualquier hora y en varios idiomas.",
      "Oportunidades de venta extra que se escapan.",
      "Reseñas que dependen de que todo salga perfecto.",
    ],
    does: [
      "Responde disponibilidad, servicios y reservas 24/7.",
      "Atiende en varios idiomas automáticamente.",
      "Ofrece extras (late check-out, parking, spa).",
      "Pide reseña tras la estancia en el momento justo.",
    ],
    agents: ["Reservas", "Conserjería", "Upselling", "Reseñas"],
    faqs: [
      { q: "¿En cuántos idiomas atiende?", a: "En el idioma del huésped automáticamente: español, inglés, alemán, francés y más." },
      { q: "¿Impulsa la reserva directa?", a: "Sí, atiende al instante y facilita la reserva directa, reduciendo comisiones de portales." },
      { q: "¿Ayuda con las reseñas?", a: "Pide la reseña en el mejor momento tras la estancia, cuando la experiencia está fresca." },
    ],
  },
  {
    slug: "fisioterapia",
    name: "Fisioterapia y rehabilitación",
    title: "IA para fisioterapia · Citas 24/7 y menos ausencias",
    meta: "Un agente de IA que coge y confirma citas, recuerda las sesiones y resuelve dudas de tus pacientes. Llena tu agenda de fisio. Empieza gratis.",
    h1: "La IA que llena tu agenda de fisio y reduce las ausencias",
    sub: "Coge y confirma citas 24/7, recuerda las sesiones y resuelve dudas de tus pacientes.",
    beneficio: "Cada sesión que no se cubre es una hora tuya perdida. Llénalas.",
    pains: [
      "No puedes atender el teléfono en plena sesión.",
      "Ausencias que dejan huecos y pierdes ingresos.",
      "Dudas repetidas sobre bonos, precios y horarios.",
    ],
    does: [
      "Agenda y reprograma sesiones por WhatsApp y teléfono.",
      "Recuerda las citas para que nadie falte.",
      "Informa de bonos, precios y primeras visitas.",
      "Ofrece los huecos libres a quien espera.",
    ],
    agents: ["Citas", "Recordatorios", "Atención al paciente", "Bonos"],
    faqs: [
      { q: "¿Recuerda las sesiones?", a: "Sí, envía recordatorios automáticos que reducen mucho las ausencias." },
      { q: "¿Gestiona bonos de sesiones?", a: "Informa de bonos y precios y puede llevar el seguimiento según tu montaje." },
      { q: "¿Atiende mientras estoy con un paciente?", a: "Sí, contesta y agenda solo, 24/7, sin que tengas que soltar al paciente." },
    ],
  },
  {
    slug: "academias",
    name: "Academias y formación",
    title: "IA para academias · Capta alumnos y resuelve dudas 24/7",
    meta: "Un agente de IA que informa de cursos y precios, apunta a clases de prueba y hace seguimiento a los interesados. Empieza gratis, sin tarjeta.",
    h1: "La IA que capta alumnos y resuelve dudas de tu academia 24/7",
    sub: "Informa de cursos y precios, apunta a clases de prueba y hace seguimiento a los interesados.",
    beneficio: "El interesado decide rápido. Si no le respondes, se matricula en otra.",
    pains: [
      "Interesados que preguntan fuera de horario.",
      "Muchas dudas repetidas de precios y horarios.",
      "Leads que no se convierten por falta de seguimiento.",
    ],
    does: [
      "Informa de cursos, precios, horarios y modalidades.",
      "Apunta a clases de prueba y gestiona matrículas.",
      "Responde dudas frecuentes al instante.",
      "Hace seguimiento a los interesados hasta que deciden.",
    ],
    agents: ["Captación", "Información de cursos", "Matrículas", "Seguimiento"],
    faqs: [
      { q: "¿Hace seguimiento a los indecisos?", a: "Sí, contacta a los interesados que no se matricularon hasta que deciden, sin que se te olvide ninguno." },
      { q: "¿Sirve para academias online y presenciales?", a: "Para las dos: informa de modalidades, horarios y precios de cada una." },
      { q: "¿Gestiona matrículas?", a: "Guía la matrícula y recoge los datos; el cobro se integra según tu sistema." },
    ],
  },
  {
    slug: "agencias",
    name: "Agencias y servicios",
    title: "IA para agencias · Atiende y cualifica cada lead 24/7",
    meta: "Un agente de IA que responde al instante, cualifica proyectos, agenda reuniones y filtra lo que no encaja. Empieza gratis, sin tarjeta.",
    h1: "La IA que atiende y cualifica cada lead de tu agencia",
    sub: "Responde al instante, cualifica proyectos, agenda reuniones y filtra lo que no encaja.",
    beneficio: "Deja de reunirte con quien no es tu cliente. Que la IA filtre por ti.",
    pains: [
      "Leads que se enfrían por tardar en contestar.",
      "Reuniones con clientes que no eran tu perfil.",
      "Tiempo perdido en primeras tomas de contacto.",
    ],
    does: [
      "Contesta a cada lead 24/7 y recoge su necesidad.",
      "Cualifica presupuesto, plazo y encaje.",
      "Agenda reuniones con el equipo adecuado.",
      "Filtra y prioriza las mejores oportunidades.",
    ],
    agents: ["Captación", "Cualificación", "Agenda", "Filtrado"],
    faqs: [
      { q: "¿Cómo cualifica un proyecto?", a: "Pregunta presupuesto, plazo y objetivo, y te dice si encaja con tus servicios antes de reunirte." },
      { q: "¿Agenda las reuniones?", a: "Sí, cuadra la reunión con tu calendario y el del cliente automáticamente." },
      { q: "¿Filtra los curiosos?", a: "Sí, prioriza los leads con encaje real y aparta los que no van en serio." },
    ],
  },
  {
    slug: "ecommerce",
    name: "Ecommerce y tiendas online",
    title: "IA para ecommerce · Atiende, vende y recupera carritos 24/7",
    meta: "Un agente de IA que resuelve dudas de producto y pedidos, recupera carritos y baja tus devoluciones. Vende 24/7. Empieza gratis, sin tarjeta.",
    h1: "La IA que atiende y vende en tu tienda online 24/7",
    sub: "Resuelve dudas de producto y pedidos, recupera carritos y baja tus devoluciones.",
    beneficio: "El 70% de los carritos se abandonan. Recupera los que puedas.",
    pains: [
      "Dudas antes de comprar que nadie contesta a tiempo.",
      "Carritos abandonados que no se recuperan.",
      "Soporte post-venta que satura tu bandeja.",
    ],
    does: [
      "Responde tallas, stock, envíos y devoluciones al instante.",
      "Recomienda productos y ayuda a decidir.",
      "Recupera carritos abandonados por WhatsApp/email.",
      "Gestiona el estado de pedidos y post-venta.",
    ],
    agents: ["Preventa", "Recuperación de carritos", "Post-venta", "Soporte"],
    faqs: [
      { q: "¿Se conecta con mi tienda (Shopify, WooCommerce)?", a: "Sí, se integra vía conexiones para consultar productos, stock y pedidos." },
      { q: "¿Recupera carritos abandonados?", a: "Sí, contacta a quien dejó la compra a medias por WhatsApp o email para cerrarla." },
      { q: "¿Baja las devoluciones?", a: "Resolviendo dudas antes de comprar (tallas, uso, compatibilidad) se reducen las devoluciones." },
    ],
  },
  {
    slug: "dentistas",
    name: "Clínicas dentales",
    title: "IA para clínicas dentales · Citas 24/7 y menos ausencias",
    meta: "Un agente de IA que agenda y confirma citas, informa de tratamientos y financiación y libera tu recepción. Empieza gratis, sin tarjeta.",
    h1: "La IA que llena tu agenda dental y reduce las ausencias",
    sub: "Agenda y confirma citas 24/7, resuelve dudas de tratamientos y presupuestos y libera tu recepción.",
    beneficio: "Un sillón vacío por una ausencia es dinero que no vuelve. Confírmalas.",
    pains: [
      "Recepción desbordada por el teléfono.",
      "Ausencias que dejan el sillón vacío.",
      "Dudas repetidas de precios, seguros y tratamientos.",
    ],
    does: [
      "Agenda, confirma y recuerda las citas.",
      "Informa de tratamientos, financiación y seguros.",
      "Reprograma y ofrece huecos libres.",
      "Deriva urgencias a una persona.",
    ],
    agents: ["Citas", "Recordatorios", "Presupuestos", "Urgencias"],
    faqs: [
      { q: "¿Reduce las ausencias?", a: "Sí, con confirmaciones y recordatorios automáticos que bajan mucho los plantones." },
      { q: "¿Informa de financiación y seguros?", a: "Sí, responde las dudas frecuentes de precios, financiación y seguros aceptados." },
      { q: "¿Gestiona urgencias?", a: "Detecta las urgencias y las deriva de inmediato a una persona." },
    ],
  },
  {
    slug: "belleza",
    name: "Estética y spa",
    title: "IA para centros de estética y spa · Citas y upselling 24/7",
    meta: "Un agente de IA que reserva tratamientos, recuerda las citas, recomienda servicios y fideliza a tus clientas. Empieza gratis, sin tarjeta.",
    h1: "La IA que llena tu centro de estética de citas 24/7",
    sub: "Reserva tratamientos, recuerda las citas, hace upselling de servicios y fideliza a tus clientas.",
    beneficio: "Mientras haces un tratamiento, la IA llena el resto de tu agenda.",
    pains: [
      "No puedes atender el teléfono durante un tratamiento.",
      "Huecos libres que no se llenan.",
      "Oportunidades de vender más servicios que se pierden.",
    ],
    does: [
      "Reserva y reprograma tratamientos por WhatsApp/teléfono.",
      "Recuerda las citas para evitar plantones.",
      "Recomienda servicios y bonos complementarios.",
      "Fideliza con seguimiento y ofertas.",
    ],
    agents: ["Citas", "Recordatorios", "Upselling", "Fidelización"],
    faqs: [
      { q: "¿Recomienda servicios adicionales?", a: "Sí, sugiere tratamientos y bonos que encajan con lo que reserva la clienta." },
      { q: "¿Fideliza a las clientas?", a: "Hace seguimiento y envía ofertas en el momento oportuno para que vuelvan." },
      { q: "¿Atiende mientras trabajo?", a: "Sí, reserva y responde solo, 24/7, sin interrumpirte." },
    ],
  },
  {
    slug: "consultoras",
    name: "Consultoras y B2B",
    title: "IA para consultoras B2B · Cualifica leads y agenda reuniones 24/7",
    meta: "Un agente de IA que atiende y cualifica cada lead B2B, agenda con el consultor adecuado y nutre a los indecisos. Empieza gratis, sin tarjeta.",
    h1: "La IA que cualifica leads y agenda reuniones para tu consultora",
    sub: "Atiende y cualifica a cada contacto 24/7, agenda con el consultor adecuado y nutre a los indecisos.",
    beneficio: "En B2B gana quien responde primero y cualifica mejor. Automatiza las dos.",
    pains: [
      "Leads B2B que se enfrían sin respuesta rápida.",
      "Reuniones con contactos fuera de perfil.",
      "Seguimiento comercial que no da abasto.",
    ],
    does: [
      "Responde y cualifica a cada lead al instante.",
      "Agenda reuniones con el consultor idóneo.",
      "Nutre a los indecisos con contenido y seguimiento.",
      "Prioriza las oportunidades con más encaje.",
    ],
    agents: ["Captación", "Cualificación", "Agenda", "Nurturing"],
    faqs: [
      { q: "¿Cómo cualifica un lead B2B?", a: "Pregunta empresa, necesidad, presupuesto y urgencia, y prioriza los de más encaje." },
      { q: "¿Hace seguimiento (nurturing)?", a: "Sí, mantiene el contacto con los indecisos con seguimiento y contenido hasta que están listos." },
      { q: "¿Se integra con mi CRM?", a: "Sí, puede registrar y actualizar los leads en tu CRM mediante conexiones." },
    ],
  },
];

// Añade las FAQ comunes al final de cada sector (sin duplicar).
SECTORS.forEach((s) => { s.faqs = [...(s.faqs || []), ...FAQ_COMUNES]; });

export const SECTORS_BY_SLUG = SECTORS.reduce((m, s) => { m[s.slug] = s; return m; }, {});
